"use strict";

module.exports = {
  System: '',
  language: 'en',
  dateFormat: 'DD/MM/YY',
  parkingAction: '//trip.holidayextras.co.uk/parking2008/c/availabilityV5',
  hotelAction: '//trip.holidayextras.co.uk/hotels2008/c/availabilityV5',
  loungeAction: '//trip.holidayextras.co.uk/lounges2008/c/availability',
  defaultParkingLocation: 'LGW',
  defaultHotelLocation: 'LGW',
  defaultLoungeLocation: 'LGW',
  defaultRoomType: 'D20',
  defaultArrivalTime: '1200',
  defaultDepartTime: '1300',
  cookieKey: 'chosenEngine',
  method: 'get',
  ruleset: 'airparks',
  flightSearch: process.env.PRODUCTION ? 'https://flight.dock-yard.io/' : 'https://flight-staging.dock-yard.io/',
  imageCloudEndpoint: process.env.PRODUCTION ? 'https://image-cloud.dock-yard.io/fetch' : 'https://image-cloud-staging.dock-yard.io/fetch',
  imageCloudWebsite: 'airparks.co.uk'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/config/formSettings.js
// module id = 757
// module chunks = 119